var _circle, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDollarSignGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    fill: "#EBFBF5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.731 9.85372C10.7368 9.06258 10.424 8.4369 9.80024 7.99504C9.31844 7.65484 8.73376 7.47738 8.16825 7.30685C6.99021 6.94972 6.64847 6.76161 6.64847 6.19825C6.64847 5.57074 7.46398 5.34747 8.16211 5.34747C8.67054 5.34747 9.25549 5.50555 9.61876 5.73982L10.339 4.62444C9.86419 4.31665 9.2144 4.10671 8.57276 4.04155V3H7.24422V4.11459C6.06326 4.37438 5.31931 5.14623 5.31931 6.19825C5.31931 6.93503 5.62548 7.51933 6.22756 7.93145C6.68549 8.24607 7.24398 8.41501 7.78347 8.57858C8.93898 8.92784 9.4082 9.14067 9.40286 9.84549L9.40284 9.85069C9.40284 10.4423 8.61886 10.6526 7.94722 10.6526C7.31277 10.6526 6.62284 10.3745 6.23175 9.9611L5.2666 10.874C5.76188 11.3979 6.48145 11.7682 7.24419 11.9134V13H8.57276V11.9368C9.88504 11.7489 10.7297 10.9589 10.731 9.85372Z",
    fill: "#22E295"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarSignGreen);
export default __webpack_public_path__ + "static/media/dollar-sign-green.cb31c291.svg";
export { ForwardRef as ReactComponent };